/*
 * @Description: 房源（项目维护）列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2021-03-30 09:55:02
 * @LastEditors: zhao - 🍉
 */

import React from 'react';
import { message, Divider, Popconfirm } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config } from '../../axios';
import { commonIsMap, dicProjectStatus } from '../../axios/dictionaries';
import ProjectAdd from './components/ProjectAdd';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_project_findProjectPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true });
        this.projectAddRef.initPack();
        this.projectAddRef.loadPack({ id });
    }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { projectId: id };
        postFrom({ url: config.API_project_deleteProject, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="d-2-3" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.projectAddRef.initPack(); }}>新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleRemove: this.handleRemove })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ProjectAdd
                    onRef={ref => this.projectAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }


}

const searchData = () => [
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在商户简称、项目编号、项目名称内模糊查询'
    },
    {
        tagName: 'Select',
        formConfig: { name: 'isJr' },
        attribute: { placeholder: '对接建行', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(commonIsMap), 
        notResult: '',
    }
];

const columns = ({ handleEdit, handleRemove }) => [
    {
        title: '项目编号',
        dataIndex: 'projectNo'
    },
    {
        title: '项目名称',
        dataIndex: 'name'
    },
    {
        title: '发布状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicProjectStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },

    {
        title: '对接建行',
        dataIndex: 'isJr',
        render(text, record, index) {
            if (!text) return '否'
            let now = commonIsMap.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 100,
        render(text, record, index) {
            return <span>
                <AuthButton authkey="d-2-2"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>
                <Divider type="vertical" />
                <AuthButton authkey="d-2-4">
                    <Popconfirm placement="top" title={"确定删除吗?"} onConfirm={() => { handleRemove(record.id) }} okText="删除" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </AuthButton>
            </span>
        }
    },
];



// WEBPACK FOOTER //
// ./src/page/RentContract/Project.js